import React, { useState, useEffect } from "react";
import {
    Dialog,
    Classes,
    InputGroup,
    TextArea,
} from "@blueprintjs/core";
import { ErrorToaster, SuccessToaster } from "./../../utils/toaster";
import { POST, PUT, TenantID, GET } from "./../dataSaver";
import style from "./index.module.scss";
import CrossPink from "./../../images/crossPink.png";
import CommonInputField from '../../Components/CommonFields/CommonInputField';
import CommonCheckBox from '../../Components/CommonFields/CommonCheckBox';
import CommonSwitch from '../../Components/CommonFields/CommonSwitch';
import CommonTextField from '../../Components/CommonFields/CommonTextField';
import CommonLabel from '../../Components/CommonFields/CommonLabel';
import CommonSelectField from '../../Components/CommonFields/CommonSelectField';

const AddTeachingActivity = ({
    getAddTeachingActivityDialog,
    isEdit,
    getTeachingActivityData,
    regionsData,
    selectedActivity,
    activity,
    contractedServiceType
}) => {
    const [teachingActivity, setTeachingActivity] = useState({
        activity: '',
        podRequired: false,
        schedule: 'WEEK',
        billable: false,
        asNeeded: false,
        activityDescription: '',
    });

    console.log(teachingActivity);
    useEffect(() => {
        if (isEdit) {
            setTeachingActivity(selectedActivity)
        }
    }, [isEdit, selectedActivity]);

    const handleTeachingActivity = (name, value) => {
        if (name === 'schedule' && value !== 'NA') {
            setTeachingActivity({ ...teachingActivity, [name]: value, asNeeded: false })
        } else if (name === 'schedule' && teachingActivity?.asNeeded) {
            setTeachingActivity({ ...teachingActivity, [name]: "NA" });
        } else {
            setTeachingActivity({ ...teachingActivity, [name]: value });
        }
    }

    const activityToAdd = async () => {
        // setIsLoading(true);
        if (teachingActivity?.activity === '') {
            ErrorToaster('Teaching Service Name is Mandatory');
            return;
        }
        if (contractedServiceType?.[1]?.defaultValue === "true" && teachingActivity?.activityDescription === '') {
            ErrorToaster('Teaching Service Description is Mandatory');
            return;
        }
        if (!isEdit && activity?.map(data => data?.activity).includes(teachingActivity?.activity)) {
            ErrorToaster('Teaching Service Name Already Exists');
            return;
        }
        let data = {
            ...(isEdit && { "id": teachingActivity?.id }),
            "activity": teachingActivity?.activity,
            "tenant": {
                "id": TenantID
            },
            "podRequired": teachingActivity?.podRequired,
            "schedule": teachingActivity?.schedule,
            "billable": teachingActivity?.billable,
            "asNeeded": teachingActivity?.asNeeded,
            "activityDescription": teachingActivity?.activityDescription,
        }
        if (!isEdit) {
            await POST(`contract-managment-service/contracts/teachingActivity`, data)
                .then(response => {
                    SuccessToaster('Activity Added to List');
                })
                .catch(error => {
                    ErrorToaster('Adding Activity To List Failed');
                })
        } else {
            await PUT(`contract-managment-service/contracts/teachingActivity/${teachingActivity?.id}`, data)
                .then(response => {
                    SuccessToaster('Activity Updated');
                })
                .catch(error => {
                    ErrorToaster('Updating Activity Failed');
                })
        }

        getAddTeachingActivityDialog(false)
    }

    return (
        <Dialog
            isOpen={getAddTeachingActivityDialog}
            onClose={() => getAddTeachingActivityDialog(false)}
            className={`${style.healthCareDialogStyle} ${style.dialogPaddingBottom}`}
        >
            <div
                className={`${Classes.DIALOG_BODY} ${style.extensionDialogBackground}`}
            >
                <div className={style.spaceBetween}>
                    <p className={style.extensionStyle}>
                        {isEdit ? "Edit" : "Add"} Teaching Activity
                    </p>
                    <img
                        src={CrossPink}
                        alt=""
                        className={`${style.colorFileStyle2} ${style.marginLeft20}`}
                        onClick={() => getAddTeachingActivityDialog(false)}
                    />
                </div>
                <div className={`${style.addonAddBox} ${style.marginTop20}`}>
                    <div className={`${style.addManagerGrid}`}>
                        <CommonLabel value='Additional Teaching Services Name' />
                        <CommonInputField placeholder='Teaching Service Name' className={style.fullWidth} value={teachingActivity?.activity} onChange={(e) => handleTeachingActivity('activity', e.target.value)} />
                    </div>
                    {
                        contractedServiceType?.[1]?.defaultValue === "true" &&
                        <div className={`${style.addManagerGrid}`}>
                            <CommonLabel value='Teaching Service Description' />
                            <TextArea rows={3} placeholder="Enter Description" value={teachingActivity?.activityDescription} onChange={(e) => handleTeachingActivity('activityDescription', e.target.value)}
                            />
                        </div>
                    }


                    <div className={`${style.addManagerGrid} ${style.marginTop20}`}>
                        <CommonLabel value='Classify As Billable Activity' />
                        <div className={`${style.threeFieldWidth} `}>
                            <CommonSwitch label={teachingActivity?.billable ? 'YES' : 'NO'} className={`${style.switchFontStyle} ${style.flexLeft} ${style.textAlignLeft}`} checked={teachingActivity?.billable} onChange={(e) => handleTeachingActivity('billable', !teachingActivity?.billable)} />
                        </div>
                    </div>

                    <div className={`${style.addManagerGrid} ${style.marginTop20}`}>
                        <CommonLabel value='Proof Of Completion / Documentation Required' />
                        <div className={style.displayInRow}>
                            <div className={`${style.threeFieldWidth} `}>
                                <CommonSwitch label={teachingActivity?.podRequired ? 'YES' : 'NO'} className={`${style.switchFontStyle} ${style.flexLeft} ${style.textAlignLeft}`} checked={teachingActivity?.podRequired} onChange={(e) => handleTeachingActivity('podRequired', !teachingActivity?.podRequired)} />
                            </div>
                            <div className={style.threeFieldWidth}>
                                <CommonLabel value='Frequency*' />
                                <CommonSelectField className={`${style.fullWidth}`}
                                    value={teachingActivity?.schedule || ''}
                                    onChange={(e) => handleTeachingActivity('schedule', e.target.value)}
                                    firstOptionLabel={'Select Frequency'} firstOptionValue={''}
                                    valueList={['NA', 'WEEK', 'MONTH', 'YEAR']}
                                    labelList={['NA', 'Per Week', 'Per Month', 'Per Year']}
                                    disabledList={[false, false, false, false, false]} />
                            </div>
                            <div className={`${style.marginTop20} ${style.marginLeft20}`}>
                                <CommonCheckBox checked={teachingActivity?.asNeeded} label='As Needed' onChange={(e) => setTeachingActivity({ ...teachingActivity, asNeeded: e.target.checked, schedule: 'NA' })} />
                            </div>

                        </div>
                    </div>

                    <div>
                        <div className={`${style.twoCol} ${style.marginTop20}`}>
                            <button className={`${style.outlinedButton} ${style.fullWidth}`} onClick={(e) => { getAddTeachingActivityDialog(false); }}>CANCEL</button>
                            <button className={`${style.buttonStyle} ${style.fullWidth}`} onClick={(e) => { activityToAdd() }}>SAVE</button>
                        </div>
                        <br />
                    </div>
                </div>

            </div>
        </Dialog>
    );
};

export default AddTeachingActivity;
